import { ElementTypeInfo } from "@cervval.js/common-dto/src/dtoModel.service";
import { anyObject } from "@cervval.js/common/src/tools/any.tools";
import { objectKeys } from "@cervval.js/common/src/tools/object.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import { BaseDTO } from "@ehealth_tools/common/src/data/dto/base.dto";
import { ID } from "@ehealth_tools/common/src/data/propertyTypes/property.types";
import { AppTableName, ElementTypes } from "./global.model";

/** Check DTO Type */
export function isDTOType<TableName extends AppTableName>(dto: anyObject | null | undefined, tableName: TableName): dto is ElementTypes[TableName] {
    return dto?.["__tableName"] === tableName;
}

export type NewOrPartialDTO<T extends BaseDTO<AppTableName>> = ((Partial<T> & { id: ID, __tableName?: undefined }) | T);

type FunctionLike = (...args: anyReallyAny[]) => anyReallyAny

export type RecursivePartial<T> = {
    [P in keyof T]?:
    T[P] extends FunctionLike | undefined ? T[P] :
    T[P] extends (infer U)[] ? RecursivePartial<U>[] :
    T[P] extends object | undefined ? RecursivePartial<T[P]> :
    T[P];
};

export interface CompanyContent {
    /** Id of the author of the content. Do not use this attribute to determine ownership of the content : the company own the content */
    authorId: ID;
    /** Id of the company that own the content. */
    ownerCompanyId: ID;
}

/** Remove "fieldToIgnore" field from the typeInfos */
export function ignoreFields<ET extends ElementTypes>(typeInfos: { [K in keyof ET]: ElementTypeInfo<ET, K, anyReallyAny> }, fieldToIgnore: string[]): { [K in keyof ET]: ElementTypeInfo<ET, K, anyReallyAny> } {
    for (const table of objectKeys(typeInfos)) {
        const tableTypeInfos = typeInfos[table];
        if (tableTypeInfos.keys) {
            const newList: (keyof ET[keyof ET])[] = [];
            for (let k = 0; k < tableTypeInfos.keys.length; k++) {
                if (!fieldToIgnore.includes(tableTypeInfos.keys[k].toString())) {
                    newList.push(tableTypeInfos.keys[k] as keyof ET[keyof ET]);
                }
            }
            tableTypeInfos.keys = newList;
        }
        if (tableTypeInfos.typeInfos.properties) {
            for (const field of objectKeys(tableTypeInfos.typeInfos.properties)) {
                if (fieldToIgnore.includes(field.toString())) {
                    delete tableTypeInfos.typeInfos.properties[field];
                }
            }
        }
    }
    return typeInfos;
}
